import { LinkOptions, DropdownOption } from './types';
import {
  QH_DEALS_URL,
  HOLIDAY_DEALS,
  QH_DESTINATION_URL,
  QCOM_LANDING_PAGE_URL,
  CONTACT_US,
  QCOM_PRIVACY_AND_SECURITY_URL,
  QCOM_TERMS_OF_USE_URL,
  DESTINATIONS_AUSTRALIA,
  FAQS,
  QFF_MY_ACCOUNT_URL,
  QFF_MY_PROFILE_URL,
  QFF_MY_POINTS_ACTIVITY_URL,
  QH_SELF_SERVICE_URL,
  QH_LIST_URL,
} from '../../lib/config';

export const NAVIGATION_DROPDOWN: DropdownOption[] = [
  {
    children: 'Australia',
    href: '/hotels/australia',
    to: '/hotels/australia',
    trackingName: 'Australia Destination',
    submenu: [
      {
        children: 'Melbourne',
        'data-testid': 'melbourne-destinations-link',
        href: '/hotels/australia/vic/melbourne',
        to: '/hotels/australia/vic/melbourne',
        trackingName: 'Melbourne Destination',
      },
      {
        children: 'Sydney',
        'data-testid': 'sydney-destinations-link',
        href: '/hotels/australia/nsw/sydney',
        to: '/hotels/australia/nsw/sydney',
        trackingName: 'Sydney Destination',
      },
      {
        children: 'Brisbane',
        'data-testid': 'brisbane-destinations-link',
        href: '/hotels/australia/qld/brisbane',
        to: '/hotels/australia/qld/brisbane',
        trackingName: 'Brisbane Destination',
      },
      {
        children: 'Perth',
        'data-testid': 'perth-destinations-link',
        href: '/hotels/australia/wa/perth',
        to: '/hotels/australia/wa/perth',
        trackingName: 'Perth Destination',
      },
      {
        children: 'Adelaide',
        'data-testid': 'adelaide-destinations-link',
        href: '/hotels/australia/sa/adelaide',
        to: '/hotels/australia/sa/adelaide',
        trackingName: 'Adelaide Destination',
      },
      {
        children: 'Darwin',
        'data-testid': 'darwin-destinations-link',
        href: '/hotels/australia/nt/darwin',
        to: '/hotels/australia/nt/darwin',
        trackingName: 'Darwin Destination',
      },
      {
        children: 'Cairns',
        'data-testid': 'cairns-destinations-link',
        href: '/hotels/australia/qld/cairns',
        to: '/hotels/australia/qld/cairns',
        trackingName: 'Cairns Destination',
      },
      {
        children: 'Surfers Paradise',
        'data-testid': 'surfers-paradise-destinations-link',
        href: '/hotels/australia/qld/surfers-paradise',
        to: '/hotels/australia/qld/surfers-paradise',
        trackingName: 'Surfers Paradise Destination',
      },
    ],
  },
  {
    children: 'By State',
    trackingName: 'By State Destination',
    submenu: [
      {
        children: 'Queensland',
        href: '/hotels/australia/qld',
        to: '/hotels/australia/qld',
        trackingName: 'Queensland Destination',
      },
      {
        children: 'New South Wales',
        href: '/hotels/australia/nsw',
        to: '/hotels/australia/nsw',
        trackingName: 'New South Wales Destination',
      },
      {
        children: 'Victoria',
        href: '/hotels/australia/vic',
        to: '/hotels/australia/vic',
        trackingName: 'Victoria Destination',
      },
      {
        children: 'Western Australia',
        href: '/hotels/australia/wa',
        to: '/hotels/australia/wa',
        trackingName: 'Western Australia Destination',
      },
      {
        children: 'Northern Territory',
        href: '/hotels/australia/nt',
        to: '/hotels/australia/nt',
        trackingName: 'Northern Territory Destination',
      },
      {
        children: 'South Australia',
        href: '/hotels/australia/sa',
        to: '/hotels/australia/sa',
        trackingName: 'South Australia Destination',
      },
      {
        children: 'Tasmania',
        href: '/hotels/australia/tas',
        to: '/hotels/australia/tas',
        trackingName: 'Tasmania Destination',
      },
      {
        children: 'Australian Capital Territory',
        href: '/hotels/australia/act',
        to: '/hotels/australia/act',
        trackingName: 'Australian Capital Territory Destination',
      },
    ],
  },
];

export const desktopLinks: LinkOptions[] = [
  {
    trackingName: 'Hotels',
    href: QH_LIST_URL,
    'data-testid': 'hotels-link',
    children: 'Hotels',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    trackingName: 'Destinations',
    href: QH_DESTINATION_URL,
    'data-testid': 'destinations-mobile-link',
    children: 'Destinations',
    dropdown: NAVIGATION_DROPDOWN,
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    trackingName: 'Hotels Deals',
    href: QH_DEALS_URL,
    'data-testid': 'deals-link',
    children: 'Hotel Deals',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    trackingName: 'Luxury Holidays',
    href: HOLIDAY_DEALS,
    'data-testid': 'luxe-link',
    children: 'Luxury Holidays',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    trackingName: 'Airbnb',
    href: QCOM_LANDING_PAGE_URL,
    'data-testid': 'airbnb-link',
    children: 'Airbnb',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
];

export const phoneLinks: LinkOptions[] = [
  ...desktopLinks,
  {
    trackingName: 'Phone Contact',
    href: CONTACT_US,
    'data-testid': 'phone-contact-link',
    children: 'Contact',
  },
  {
    trackingName: 'Phone Privacy Security',
    href: QCOM_PRIVACY_AND_SECURITY_URL,
    'data-testid': 'phone-privacy-security-link',
    children: 'Privacy & Security',
  },
  {
    trackingName: 'Phone Term Of Use',
    href: QCOM_TERMS_OF_USE_URL,
    'data-testid': 'phone-term-of-use-link',
    children: 'Terms of use',
  },
  {
    trackingName: 'Phone Australian Destinations',
    href: DESTINATIONS_AUSTRALIA,
    'data-testid': 'phone-australian-destinations-link',
    children: 'Australian destinations',
  },
  {
    trackingName: 'Phone Faqs',
    href: FAQS,
    'data-testid': 'phone-faqs-link',
    children: 'FAQs',
  },
];

export const qffLinks: LinkOptions[] = [
  {
    trackingName: 'My Account',
    href: QFF_MY_ACCOUNT_URL,
    target: '_blank',
    rel: 'noreferrer noopener',
    'data-testid': 'my-account-link',
    children: 'My account',
  },
  {
    trackingName: 'My Hotel Bookings',
    href: QH_SELF_SERVICE_URL,
    target: '_blank',
    rel: 'noreferrer noopener',
    'data-testid': 'my-bookings-link',
    children: 'My hotel bookings',
  },
  {
    trackingName: 'My Points Activity',
    href: QFF_MY_POINTS_ACTIVITY_URL,
    target: '_blank',
    rel: 'noreferrer noopener',
    'data-testid': 'my-points-link',
    children: 'My points activity',
  },
  {
    trackingName: 'My Profile',
    href: QFF_MY_PROFILE_URL,
    target: '_blank',
    rel: 'noreferrer noopener',
    'data-testid': 'my-profile-link',
    children: 'My profile',
  },
];

export const desktopDropdownLinks = [
  {
    trackingName: 'Hotels',
    href: '/search/list',
    'data-testid': 'hotels-link',
    children: 'Hotels',
    usesQueryParams: true,
  },
  {
    trackingName: 'Destinations',
    'data-testid': 'destinations-link',
    children: 'Destinations',
    href: '/hotels/australia',
    dropdown: [
      {
        children: 'Australia',
        href: '/australia',
        trackingName: 'Australia Destination',
        submenu: [
          {
            children: 'Melbourne',
            'data-testid': 'melbourne-destinations-link',
            href: '/australia/vic/melbourne',
            trackingName: 'Melbourne Destination',
          },
          {
            children: 'Sydney',
            'data-testid': 'sydney-destinations-link',
            href: '/australia/nsw/sydney',
            trackingName: 'Sydney Destination',
          },
        ],
      },
      {
        children: 'By State',
        trackingName: 'By State Destination',
        submenu: [
          {
            children: 'Queensland',
            href: '/australia/qld',
            trackingName: 'Queensland Destination',
          },
          {
            children: 'New South Wales',
            href: '/australia/nsw',
            trackingName: 'New South Wales Destination',
          },
        ],
      },
    ],
  },
  {
    trackingName: 'Hotel Deals',
    'data-testid': 'deals-link',
    children: 'Hotels Deals',
    href: '/hotels/deals',
  },
  {
    trackingName: 'Luxury Offers',
    'data-testid': 'luxe-link',
    children: 'Luxury Offers',
    href: '/hotels/luxe',
  },
  {
    trackingName: 'Holiday Packages',
    'data-testid': 'holiday-packages-link',
    children: 'Holiday Packages',
    href: '/hotels/packages',
  },
  {
    trackingName: 'Airbnb',
    'data-testid': 'airbnb-link',
    target: '_blank',
    rel: 'noreferrer noopener',
    children: 'Airbnb',
    href: 'www.airbnb.com',
  },
];

export const phoneDropdownLinks = [
  {
    trackingName: 'Hotels',
    href: '/search/list',
    'data-testid': 'hotels-link',
    children: 'Hotels',
    usesQueryParams: true,
  },
  {
    trackingName: 'Destinations',
    href: '/australia',
    'data-testid': 'destinations-mobile-link',
    children: 'Destinations',
  },
  {
    trackingName: 'Hotel Deals',
    'data-testid': 'deals-link',
    children: 'Hotels Deals',
    href: '/hotels/deals',
  },
  {
    trackingName: 'Luxury Offers',
    'data-testid': 'luxe-link',
    children: 'Luxury Offers',
    href: '/hotels/luxe',
  },
  {
    trackingName: 'Holiday Packages',
    'data-testid': 'holiday-packages-link',
    children: 'Holiday Packages',
    href: '/hotels/packages',
  },
  {
    trackingName: 'Airbnb',
    'data-testid': 'airbnb-link',
    children: 'Airbnb',
    href: 'www.airbnb.com',
  },
];
